/**
 * Enum for event location map types.
 */
export var MapType = {
    APPLE: 'APPLE',
    GOOGLE: 'GOOGLE'
};
/**
 * get the Map type enum number based on the locationMapType account settings.
 * Also support Map type name for existing snapshots.
 * @param locationMapType
 * @returns Map type enum number
 */
export function migrateMapTypeIsNeeded(locationMapType) {
    if (locationMapType === MapType.APPLE) {
        return 1;
    }
    if (locationMapType === MapType.GOOGLE) {
        return 2;
    }
    return locationMapType;
}
/**
 * get the Map type enum number based on the locationMapType account settings.
 * @param locationMapType
 * @returns True for Apple Map
 */
export function isAppleMap(locationMapType) {
    return locationMapType === 1;
}
